import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import baseURL from './baseURL/BaseURL';

const ForgotPasswordScreen = () => {
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setMessage('');
    setLoading(true);

    if (!email) {
      setErrors({ email: 'Email is required' });
      setLoading(false);
      return;
    }

    try {
      const response = await baseURL.post(`/users/password`, {user:{ email }});
      if (response.status === 200) {
        setMessage('Password reset link has been sent to your email.');
      }
    } catch (error) {
      setErrors({ apiError: 'Email not found. Please try again.' });
    }
    setLoading(false);
  };

  return (
    <div className="flex h-screen">
      <div className="w-1/2 max-md:w-full flex flex-col justify-center items-center bg-white px-8">
        <div className="w-full max-w-md">
          <h2 className="text-3xl font-bold text-center mb-2">Forgot Password?</h2>
          <p className="text-center text-gray-500 mb-6">Enter your email to receive a reset link.</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-gray-600 mb-1">Email</label>
              <input
                type="email"
                placeholder="Enter your email"
                className={`w-full px-4 py-2 border ${errors.email ? 'border-[#730000]' : 'border-gray-300'} rounded-md`}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {errors.email && <p className="text-[#730000] text-sm mt-1">{errors.email}</p>}
            </div>

            {errors.apiError && <p className="text-[#730000] text-sm mt-1">{errors.apiError}</p>}
            {message && <p className="text-green-600 text-sm mt-1">{message}</p>}

            <button
              type="submit"
              className="w-full bg-[#730000] text-white py-2 rounded-md font-semibold"
              disabled={loading}
            >
              {loading ? "Sending..." : "Send Reset Link"}
            </button>
          </form>

          <p className="text-center mt-4">
            <Link to="/login" className="text-blue-500 hover:underline">Back to Login</Link>
          </p>
        </div>
      </div>
      <div className="w-1/2 max-md:hidden relative flex items-center justify-center">
          <img
            src="https://plus.unsplash.com/premium_vector-1721219771657-0b6c64520575?q=80&w=2960&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            alt="Illustration"
            className="z-10 w-80"
          />
        </div>
    </div>
  );
};

export default ForgotPasswordScreen;
